import React from 'react';
import styles from './Input.module.scss';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';

export function Input({ type, placeholder, label, defaultValue, onChange, readOnly, value, error = false }) {
  return (
    <div className={styles.InputComponent}>
      <label className={styles.label}>{label}</label>
      <input
        value={value}
        readOnly={readOnly}
        onChange={onChange}
        defaultValue={defaultValue}
        className={styles.InputStyles}
        type={type}
        placeholder={placeholder}
      />
      {error && <ValidationErrorLabel message={error} />}
    </div>
  );
}
